import { createReducer, on, Action } from '@ngrx/store';

import * as AffiliateOptions from './affiliate-options.actions';
import { AffiliateOption } from '@shared/services/affiliate/_interfaces_/affiliate-options.interface';

export class AffiliateOptionsModel {
  data: AffiliateOption[] | null;
}

const initialState: AffiliateOptionsModel = new AffiliateOptionsModel();

const reducer = createReducer(
  initialState,
  on(AffiliateOptions.setAffiliateOptions, (state, { data }) => ({ data })),
);

export function affiliateOptionsReducer(state: AffiliateOptionsModel, action: Action) {
  return reducer(state, action);
}
